export const PAYMENT_STATUSES = {
    PENDING: 'pending',
    PAID: 'paid',
    AUTO_REFUND_PENDING: 'auto_refund_pending',
    AUTO_REFUNDED: 'auto_refunded',
    AUTO_REFUND_FAILED: 'auto_refund_failed'
}
